import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router';
import { useDispatch } from 'react-redux';
import { logout } from '../../store';

const Logout = () => {
  const [redirect, setRedirect] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logout());
    setRedirect(<Redirect to='login' />);
  }, [setRedirect, dispatch]);

  return <div>{redirect}</div>;
};

export default Logout;
